"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filter = exports.uniq = exports.uniqBy = void 0;
var piper_1 = require("@kofno/piper");
var uniqBy = function (fn) { return function (ts) {
    var set = new Set();
    var result = [];
    ts.forEach(function (t) {
        var compareItem = fn(t);
        if (!set.has(compareItem)) {
            set.add(compareItem);
            result.push(t);
        }
    });
    return result;
}; };
exports.uniqBy = uniqBy;
exports.uniq = exports.uniqBy(piper_1.identity);
function filter(fn, ts) {
    var doit = function (ts) { return ts.filter(fn); };
    return typeof ts === 'undefined' ? doit : doit(ts);
}
exports.filter = filter;
